import { render, staticRenderFns } from "./StarterCopy.vue?vue&type=template&id=466c1f5f"
import script from "./StarterCopy.vue?vue&type=script&lang=js"
export * from "./StarterCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports